// Shows /images/logo.png exactly as supplied. The file has empty padding around the artwork,
// so the wrapper clips the view to the artwork (433x115 of the 622x401 image) using CSS only.
export const Logo = ({ className = '' }) => (
  <span className={`relative block overflow-hidden ${className}`} style={{ aspectRatio: '433 / 115' }}>
    <img
      src="/images/logo.png"
      alt="Ehimo Building & Civil Engineering Ltd."
      className="absolute max-w-none"
      style={{ width: '143.64%', left: '-21.71%', top: '-111.3%' }}
    />
  </span>
);
